import { useState, useEffect } from 'react'
import { Dialog, DialogBody, DialogContent, DialogHeader, DialogTitle } from '@cutilei/ui'
import AuthService from 'services/auth'
import cutileiApi from 'services/cutileiApi'
import { logApiError } from 'services/apiError'
import BusinessBillList from 'components/Lists/BusinessBillList'
import { ReactComponent as Loading } from 'icons/loading2.svg'

import { Container } from './styles'

export default function BusinessBillsModal ({
  visible,
  date,
  paymentMethod,
  bankAccount,
  cardFlag,
  onClose: handleClose
}) {
  const [loading, setLoading] = useState (true)
  const [bills, setBills] = useState ([])
  const token = AuthService.getToken ()
  const businessId = AuthService.getBusinessId ()

  useEffect (() => {
    getBills ()
  }, [visible])

  const requestConfig = {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  }

  const getBills = async () => {
    let filters = `business_id=${businessId}&deleted=false&date=${date}`
    if (paymentMethod) filters += `&payment_method_id=${paymentMethod?.id}`
    if (bankAccount) filters += `&bank_account_id=${bankAccount?.id}`
    if (cardFlag) filters += `&card_flag_id=${cardFlag?.id}`

    try {
      const { data: bills } = await cutileiApi.get (
        `/business_bills?${filters}`, requestConfig
      )
      setBills (bills)
    } catch (error) {
      logApiError (error)
    } finally {
      setLoading (false)
    }
  }

  return (
    <Dialog open={visible} onOpenChange={open => { if (!open) handleClose() }}>
      <DialogContent size='xl' aria-describedby={undefined}>
        <DialogHeader>
          <DialogTitle>Comandas</DialogTitle>
        </DialogHeader>
        <DialogBody>
          <Container>
            {loading ? <Loading style={{marginBottom: 20}}/> : (
              <BusinessBillList
                bills={bills}
                paymentMethod={paymentMethod}
                cardFlag={cardFlag}
                bankAccount={bankAccount}
                containerStyle={{paddingInline: 10}}
                onEdit={bill => setBills (bills.map (b => b.id === bill.id ? {...bill} : b))}
                onDelete={bill => setBills (bills.filter (b => b.id !== bill.id))}
              />
            )}
          </Container>
        </DialogBody>
      </DialogContent>
    </Dialog>
  )
}
